const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
  log: (...args) => isDev && console.log(...args),
  debug: (...args) => isDev && console.debug(...args),
  warn: (...args) => isDev && console.warn(...args),
  error: (...args) => console.error(...args), // always show errors
};
